module.exports = {"150802001":"团结","150802002":"车站","150802003":"先锋","150802004":"解放","150802005":"新华","150802006":"东环路","150802007":"铁南","150802008":"西环路","150802009":"北环路","150802013":"金川","150802014":"汇丰","150802100":"狼山镇","150802101":"新华镇","150802102":"干召庙镇","150802103":"乌兰图克镇","150802104":"双河镇","150802105":"城关镇","150802106":"白脑包镇","150802200":"曙光乡","150802201":"八一乡","150802400":"狼山农场","150802401":"临河农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150802.json
// module id = 459
// module chunks = 0